import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import firebase, { auth, db } from '../settings/firebase';

const useStyles = makeStyles((theme) => ({
  settingreconnectsnsbutton: {
    height: "2.6em",
    width: "6em",
    minWidth: "6em",
    borderRadius: "1.3em",
    backgroundColor: theme.palette.primary.main,
    marginTop: ".3em",
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      cursor: "pointer",
    },
    '&:disabled': {
      cursor: "not-allowed"
    }
  },
  settingunconnectsnsbutton: {
    height: "2.6em",
    width: "6em",
    minWidth: "6em",
    borderRadius: "1.3em",
    backgroundColor: theme.palette.primary.main,
    marginTop: ".3em",
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      cursor: "pointer",
    },
  },
  settingrightarea: {
    display: "flex",
    width: "50vw", 
    justifyContent: "space-between",
  },
  settinginputsnsurl: {
    fontSize: "14px", marginTop: ".3em", width: "10em",
    border: "0",
    borderBottomColor: "#aaaaaa",
    borderBottom: "1px solid",
    '&:focus': {outline: "none", borderColor: theme.palette.primary.main},
  }
}));

export default function SettingSns(props) {
  const { state, children, type, onChange, updateSns } = props;
  const classes = useStyles();
  const urldomain = {instagram: "instagram.com", note: "note.com", tiktok: "www.tiktok.com", youtube: "youtube.com"}

  const connectSns = () => {
    // AuthProviderオブジェクトの取得
    let provider = new firebase.auth.GoogleAuthProvider();
    if (type === "facebook") provider = new firebase.auth.FacebookAuthProvider();
    if (type === "twitter") provider = new firebase.auth.TwitterAuthProvider();
    
    auth.currentUser.linkWithPopup(provider).then((result) => {
      console.log(type+"のリンクに成功しました。", result.credential, result.user);
      onChange(type + "との連携が有効になりました");
      updateSns(type, result.user);
    }).catch((error) => {
      console.log(type+"のリンクに失敗しました。", error);
      onChange(type + "との連携ができませんでした");
    });
  }

  const unconnectSns = () => {
    auth.currentUser.unlink(type + ".com").then(() => {
      console.log(type+"の連携を解除しました。");
      onChange(type + "との連携を解除しました");
      updateSns(type);
    }).catch((error) => {
      console.log(type+"の連携解除に失敗しました。", error);
      onChange(type+"の連携解除に失敗しました。");
    });
  }

  const changeSnsurl = (e) => {
    let reg = /^[A-Za-z0-9_.]*$/g;
    if (type === 'youtube') reg = /^[A-Za-z0-9\-_]*$/g;
    if (reg.test(e.target.value)) {
      const obj = {url: e.target.value, nowurl: state.nowurl}
      updateSns(type, obj);
    } else {
      onChange("URLに使用できない文字です。");
    }
  }

  const setSnsurl = () => {
    let obj = {url: state.url, nowurl: state.url}
    if (state.nowurl !== "" && state.nowurl !== undefined) {
      obj = {url: "", nowurl: ""};
    }
    let data = {};
    data[type] = obj.url;
    db.collection("users").doc(auth.currentUser.uid).update(data).then(e => {
      updateSns(type, obj);
      onChange(type + "連携設定を変更しました");
    })
  }

  return (
    <div className={"inputarea-center-div"}>
      <p className={"inputarea-center-label snsiconlabel"}>{children}</p>
      <div className={classes.settingrightarea}>
      {["google", "twitter", "facebook"].indexOf(type) !== -1?
        state?
          <>
            <p id={"setting-"+type+"-text1"} className={"inputsettng"} style={{width: "30vw", marginTop: ".3em"}}>
              {state.name}<br/>{type === "google"? state.mail: "ID: " + state.uid}
            </p>
            <button className={classes.settingunconnectsnsbutton} onClick={unconnectSns}>解除する</button>
          </>
        :
          <>
            <p id={"setting-"+type+"-text2"} className={"inputsettng"} style={{marginTop: ".3em"}}>未連携</p>
            <button className={classes.settingreconnectsnsbutton} onClick={connectSns}>連携する</button>
          </>
      :
        <>
          <p id={"setting-"+type+"-text"} className={"inputsettng"} style={{display: "flex", marginTop: ".3em", flexWrap: "wrap", overflow: "visible"}}>
            {urldomain[type]}/{state.nowurl !== "" && state.nowurl !== undefined?
              <span>{state.url}</span>
            :
              <input onChange={changeSnsurl} value={state.url} className={classes.settinginputsnsurl} placeholder="URLを入力（未連携）" />
            }
          </p>
          {state.nowurl !== "" && state.nowurl !== undefined?
            <button className={classes.settingunconnectsnsbutton} onClick={setSnsurl}>解除する</button>
          :
            <button
              className={classes.settingreconnectsnsbutton} onClick={setSnsurl}
              disabled={state.url === "" || state.url === undefined? true:false}
            >
              連携する
            </button>
          }
        </>
      }
      </div>
    </div>
  )
}